import { useEffect, useState } from "react";
import "./style.css";
import HeartRateAnimation from "./HeartRate/HeartRate";

interface ErrorScreenProps {
    message?: string;
    title?: string;
    description?: string;
    footer?: string;
    showTimer?: boolean;
    timerSeconds?: number;
}
export default function ErrorScreen({
    message = "",
    title = "",
    description = "",
    footer = "",
    showTimer = false,
    timerSeconds = 180
}: ErrorScreenProps) {
    const [timeLeft, setTimeLeft] = useState(timerSeconds);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
        if (showTimer) {
            const interval = setInterval(() => {
                setTimeLeft((prev) => Math.max(prev - 1, 0));
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [showTimer, timerSeconds]);

    const formatTime = (s: number) =>
        `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

    return (
        <main className="mainContainer">
            <div className="contentWrapper">
                <div className="circleContainer">
                    <div className={`backgroundCircle ${isLoaded ? "loaded" : ""}`} style={{ backgroundColor: "#508fe7" }} />
                    <div className={`mainCircle ${isLoaded ? "loaded" : ""}`}>
                        <div className="animationWrapper">
                            <HeartRateAnimation />
                        </div>
                        {message && <p className="circleText">{message}</p>}
                        {showTimer && <p className="timer">{formatTime(timeLeft)}</p>}
                    </div>
                </div>

                <div className={`contentSection ${isLoaded ? "contentLoaded" : ""}`}>
                    {title && <h1 className="heading">{title}</h1>}
                    {description && (
                        <p className="description">
                            {description}
                        </p>
                    )}
                    {footer && <p className="footer">{footer}</p>}
                </div>
            </div>
        </main>
    );
}
